import cx from 'classnames'
import styles from './NavigationTabs.module.scss'
import { useWindowSize } from '~utils/hooks'
import { useRouter } from 'next/router'
import { DropDown } from '~elements'
import { useMemo } from 'react'

type TabsType = {
  label: string
  url: string
}

type Props = {
  tabs?: TabsType[]
}

const NavigationTabs = ({ tabs }: Props) => {
  const router = useRouter()
  const { isBreakpoint: isBelowMd } = useWindowSize('sm', '<')

  // Find the initially selected tab based on current route
  const initialSelectedValue = useMemo(() => {
    const currentTab = tabs?.find(tab => router.asPath === tab.url)
    return currentTab?.url || ''
  }, [tabs, router.asPath])

  const normalizeDropDownOptions = useMemo(() => {
    return tabs?.map(tab => ({
      ...tab,
      value: tab.url
    }))
  }, [tabs])

  const handleDropDownChange = (value: string) => {
    router.push(value)
  }
  if (!tabs?.length) return null
  return (
    <div className={cx(styles['navigation-tabs'], isBelowMd && styles['navigation-tabs--dropdown'])}>
      <>
        {isBelowMd ? (
          <DropDown
            theme='muted'
            options={normalizeDropDownOptions}
            showPlaceholderInMenu={false}
            onDropDownChange={handleDropDownChange}
            initialSelectedValue={initialSelectedValue}
            highlightSelectedValue
          />
        ) : (
          <>
            {tabs.map((tab, index: number) => {
              const isActive = router.asPath === tab.url
              const displayLabel = tab.label

              const formattedLabel = displayLabel
              return (
                <span
                  id={index.toString()}
                  key={index}
                  className={cx(
                    styles['navigation-tabs__tab'],
                    isActive && styles['navigation-tabs__tab--active'],
                    isBelowMd && styles['navigation-tabs__tab--dropdown']
                  )}
                  onClick={() => router.push(tab.url)}
                  tabIndex={0}
                >
                  {formattedLabel}
                </span>
              )
            })}
          </>
        )}
      </>
    </div>
  )
}

export default NavigationTabs
